import {
  CREATE_BUSINESS_SERVICE_OPERATION,
  DELETE_BUSINESS_SERVICE_OPERATION,
  LIST_BUSINESS_SERVICES_OPERATION,
  RESTORE_BUSINESS_SERVICE_OPERATION,
  UPDATE_BUSINESS_SERVICE_OPERATION,
  type GeneratedCreateBusinessServiceRequest,
  type GeneratedCreateBusinessServiceResponse,
  type GeneratedListBusinessServicesQuery,
  type GeneratedListBusinessServicesResponse,
  type GeneratedRestoreBusinessServiceResponse,
  type GeneratedUpdateBusinessServiceRequest,
  type GeneratedUpdateBusinessServiceResponse,
} from './generated-business';
import {
  buildQueryString,
  performAuthorizedRequest,
  replacePathParams,
} from './business-request';

export async function listBusinessServicesRequest(
  token: string,
  businessId: number,
  query: Partial<GeneratedListBusinessServicesQuery> = {}
): Promise<GeneratedListBusinessServicesResponse> {
  return performAuthorizedRequest<GeneratedListBusinessServicesResponse>(
    token,
    {
      ...LIST_BUSINESS_SERVICES_OPERATION,
      path:
        replacePathParams(LIST_BUSINESS_SERVICES_OPERATION.path, {
          business_id: businessId,
        }) +
        buildQueryString({
          name: query.name,
          q: query.q,
          public_booking_enabled: query.public_booking_enabled,
          status: query.status,
          page: query.page,
          limit: query.limit,
        }),
    },
    {
      networkErrorMessage:
        'Não foi possível obter os serviços. Verifique se o backend está disponível.',
      requestErrorMessage: 'Não foi possível carregar os serviços agora.',
    }
  );
}

export async function createBusinessServiceRequest(
  token: string,
  businessId: number,
  service: GeneratedCreateBusinessServiceRequest
): Promise<GeneratedCreateBusinessServiceResponse> {
  return performAuthorizedRequest<GeneratedCreateBusinessServiceResponse>(
    token,
    {
      ...CREATE_BUSINESS_SERVICE_OPERATION,
      path: replacePathParams(CREATE_BUSINESS_SERVICE_OPERATION.path, {
        business_id: businessId,
      }),
    },
    {
      body: service,
      networkErrorMessage:
        'Não foi possível criar o serviço. Verifique se o backend está disponível.',
      requestErrorMessage: 'Não foi possível criar o serviço agora.',
    }
  );
}

export async function updateBusinessServiceRequest(
  token: string,
  businessId: number,
  serviceId: number,
  service: GeneratedUpdateBusinessServiceRequest
): Promise<GeneratedUpdateBusinessServiceResponse> {
  return performAuthorizedRequest<GeneratedUpdateBusinessServiceResponse>(
    token,
    {
      ...UPDATE_BUSINESS_SERVICE_OPERATION,
      path: replacePathParams(UPDATE_BUSINESS_SERVICE_OPERATION.path, {
        business_id: businessId,
        id: serviceId,
      }),
    },
    {
      body: service,
      networkErrorMessage:
        'Não foi possível atualizar o serviço. Verifique se o backend está disponível.',
      requestErrorMessage: 'Não foi possível atualizar o serviço agora.',
    }
  );
}

export async function deleteBusinessServiceRequest(
  token: string,
  businessId: number,
  serviceId: number
) {
  await performAuthorizedRequest(
    token,
    {
      ...DELETE_BUSINESS_SERVICE_OPERATION,
      path: replacePathParams(DELETE_BUSINESS_SERVICE_OPERATION.path, {
        business_id: businessId,
        id: serviceId,
      }),
    },
    {
      networkErrorMessage:
        'Não foi possível arquivar o serviço. Verifique se o backend está disponível.',
      requestErrorMessage: 'Não foi possível arquivar o serviço agora.',
    }
  );
}

export async function restoreBusinessServiceRequest(
  token: string,
  businessId: number,
  serviceId: number
): Promise<GeneratedRestoreBusinessServiceResponse> {
  return performAuthorizedRequest<GeneratedRestoreBusinessServiceResponse>(
    token,
    {
      ...RESTORE_BUSINESS_SERVICE_OPERATION,
      path: replacePathParams(RESTORE_BUSINESS_SERVICE_OPERATION.path, {
        business_id: businessId,
        id: serviceId,
      }),
    },
    {
      networkErrorMessage:
        'Não foi possível restaurar o serviço. Verifique se o backend está disponível.',
      requestErrorMessage: 'Não foi possível restaurar o serviço agora.',
    }
  );
}
